import React from "react";
import { Box, Card, CardContent } from "@material-ui/core";
import CardHeading from "src/components/CardHeader/CardHeader";
import TabHeader from "src/components/TabHeader/TabHeader";
import { useStyles } from "./styles";

type Props = {
  module: string;
  children: any;
  heading: string;
  GridDataComp?: any;
};

export default function CommonDataGridPage({ module, children, heading, GridDataComp }: Props) {
  const classes = useStyles();

  return (
    <>
      <TabHeader module={module || "module"} heading={heading || "heading"} />
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <CardHeading heading={heading || "heading"} />
          <Card>
            <CardContent className={classes.cardSec}>{children}</CardContent>
            {GridDataComp && GridDataComp}
          </Card>
        </CardContent>
      </Card>
    </>
  );
}
